import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material/material.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from './button/button.component';
import { InputComponent } from './input/input.component';




@NgModule({
  declarations: [
    ButtonComponent,
    InputComponent
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MaterialModule
  ],
  exports:[
    ButtonComponent,
    InputComponent
  ],
  providers:[TranslateService],
  schemas:[NO_ERRORS_SCHEMA]
})
export class UtilComponentsModule { }
